export enum ReportEntity {
    NOTIFICATIONS = 'notifications',
    PROMPTS = 'prompts',
    CAMPAIGNS = 'campaigns',
    PUB_NETWORK = 'pub_network',
    SEGMENTS = 'segments',
    MONTHLY_UNIQUES = 'monthly_uniques',
    DAILY_UNIQUES = 'daily_uniques',
    APP_MESSAGES = 'app_messages',
    LIVE_ACTIVITIES = 'live_activities',
}
